<div class="modal fade" id="modalDeviceApiLogs" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title modal-titles" id="exampleModalLabel" style="font-weight: bold">
                    SIM Update Logs
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="ondDismissModal()"></button>
            </div>
            <div class="modal-body">
                <app-table-control [data]="logsCallback" [columns]="columns" [pageSize]="5" [showCheckboxes]="false">
                </app-table-control>
            </div>
        </div>
    </div>
</div>